module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "Dedication"
  }, [_vm._v("To Mr. Hockey — as they say, he wasn’t in a class all by himself, but it didn’t take long to take attendance."), _c('br'), _vm._v("—D.S.")]), _vm._v(" "), _c('p', {
    staticClass: "Acknowledgement"
  }, [_vm._v("Special thanks to Baron Bedesky, Coordinator of Player Research and Relations, Professional Hockey Players’ Association.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56c9b7be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/ded.vue
// module id = 60
// module chunks = 0